import React, { useEffect, useState } from "react";
import MainImage3 from "../assets/Blackwomen/BWI22.jpg";
import NavLite from "./NavLite";

function Hero() {
  const [bgLoaded, setBgLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = MainImage3;
    img.onload = () => setBgLoaded(true);
  }, []);

  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1]">
<div
  className={`relative min-h-screen transition-opacity duration-1000 ease-in-out ${
    bgLoaded ? "opacity-100" : "opacity-0"
  }`}
  style={{
    backgroundImage: `url(${MainImage3})`,
    backgroundSize: "cover",
    backgroundPosition: "right center",
    backgroundRepeat: "no-repeat",
  }}
>
        {/* Navbar */}
        <NavLite />

        <header className="relative z-10 flex items-center h-full pb-10">
          {/* Left side content */}
          <div className="w-full md:w-1/2 flex items-center justify-center h-full px-5 md:px-10 pt-32">
            <div className="backdrop-blur-sm max-w-xl space-y-6 text-left">
              <h1 className="text-3xl md:text-6xl font-bold text-[#CFF098] leading-tight">
               <span className="italic">Run Your Business. {" "}</span>
                <span className=" text-white text-3xl md:text-5xl">We’ll Power Your Growth Behind the Scenes.</span>
              </h1>
              <p className="text-[18px] font-medium text-white italic">
              No more cookie-cutter sites or DIY headaches. We build custom websites and growth systems for women entrepreneurs who are ready to scale with confidence. From branding to tech to marketing, we’ve got you covered so you can focus on what you do best.
              </p>
              <a
                href="/templateshop"
                className="inline-flex items-center gap-2 bg-[#CFF098] px-6 py-3 text-sm text-black border border-black rounded-full hover:opacity-60 w-fit"
              >
                CUSTOMIZABLE APPS AND WEBSITES →
              </a>
            </div>
          </div>
        </header>
      </div>
    </main>
  );
}

export default Hero;
